// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "container-13_6t";
var _3 = "selector-DgdNK";
var _4 = "selected-TLtXk";
var _5 = "description-GsY9X";
var _6 = "BaggageExcess-123dC";
var _7 = "footer-26TJr";
var _8 = "title_price-3zpot";
var _9 = "price-1R8Hn";
var _a = "icon-2tchO";
var _b = "oneService-1T2rh";
export { _1 as "__esModule", _2 as "container", _3 as "selector", _4 as "selected", _5 as "description", _6 as "BaggageExcess", _7 as "footer", _8 as "title_price", _9 as "price", _a as "icon", _b as "oneService" }
export default { "__esModule": _1, "container": _2, "selector": _3, "selected": _4, "description": _5, "BaggageExcess": _6, "footer": _7, "title_price": _8, "price": _9, "icon": _a, "oneService": _b }
